import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import Typography from 'Components/UI/Typography';
import Button from 'Components/UI/Button';
import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import useDrawerState from 'Hooks/useDrawerState';
import Dialog from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Dialog';
import Slide from '@mui/material/Slide';
import MuiAppBar from '@material-ui/core/AppBar';
import MuiToolbar from '@material-ui/core/Toolbar';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const IMG_HEIGHT = 255;

const styles = (theme) => ({
  root: {
    minWidth: 275,
    width: 275,
    height: 465,
    borderRadius: theme.radius.md,
    overflow: 'hidden',
  },
  image: {
    borderBottomRightRadius: theme.radius.md,
    borderBottomLeftRadius: theme.radius.md,
    height: IMG_HEIGHT,
    width: 275,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  content: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100% - ${IMG_HEIGHT}px)`,
    maxHeight: `calc(100% - ${IMG_HEIGHT}px)`,
    overflow: 'hidden',
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  frameContainer: {
    minWidth: '100%',
    maxWidth: '100%',
    width: '100%',
    height: '100%',
  },
  iframe: {
    minWidth: '100%',
    maxWidth: '100%',
    width: '100%',
    height: '100%',
  },
  excerpt: {
    marginBottom: theme.spacing(1),
    color: theme.palette.facet.primaryGray,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightBold,
    flexGrow: 1,
    overflow: 'hidden',
  },
  viewButton: {
    width: 'fit-content',
    alignSelf: 'flex-start',
  },
  appBar: {
    position: 'unset',
  },
});

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CuratedContentCarouselCard = ({
  classes,
  className,
  resource,
}) => {
  const { open, toggleDrawer } = useDrawerState();

  const contentUrl = resource?.relationship('url')?.link('related')?.url();

  return (
    <Paper className={classNames(classes.root, className)}>
      <div
        className={classes.image}
        style={{
          backgroundImage: `url(${resource.withRelationship(fr.relationships.image.name,
            () => resource.relationship(fr.relationships.image.name).link('related').url(),
            () => '')}`,
        }}
      />
      <div className={classes.content}>
        <Typography variant="h4" color="accentBlue2" weight="medium" className={classes.title}>
          {resource.attr('name')}
        </Typography>
        <RichTextDisplay content={resource.attr('excerpt')} className={classNames(classes.excerpt)} />
        {contentUrl && (
          <Button
            color="accentBlue"
            className={classes.viewButton}
            onClick={(event) => {
              event.stopPropagation();
              toggleDrawer();
            }}
          >
            {'View'}
          </Button>
        )}
      </div>
      <Dialog
        fullScreen
        onClose={toggleDrawer}
        open={open}
        TransitionComponent={Transition}
      >
        <MuiAppBar className={classNames(classes.appBar)}>
          <MuiToolbar>
            <Button
              color="white"
              startIcon={<ArrowBackIosIcon />}
              onClick={toggleDrawer}
            >
              {'Back'}
            </Button>
          </MuiToolbar>
        </MuiAppBar>
        <iframe
          title={`article-${resource.id()}`}
          src={contentUrl}
          frameBorder={0}
          className={classNames(classes.iframe)}
        />
      </Dialog>
    </Paper>
  );
};

CuratedContentCarouselCard.defaultProps = {
  className: '',
};

CuratedContentCarouselCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(CuratedContentCarouselCard);
